<script
    setup
    lang="ts"
    generic="
    ListingFilter extends {
      code: string;
      label: string;
      name: string;
      options: Array<Schemas['PropertyGroupOption']>;
    }
  "
>
import { inject, ref } from "vue";
import { getTranslatedProperty } from "@shopware/helpers";
import type { Schemas } from "#shopware";

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: {
    [key: string]: any;
  };
}>();

const emits = defineEmits<{
  (e: "select-value", value: { code: string; value: unknown }): void;
}>();
const selectedOptionIds = inject<string[]>("selectedOptionIds");
const isFilterVisible = ref<boolean>(false);
const toggle = () => {
  isFilterVisible.value = !isFilterVisible.value;
};

const filterBody = ref(null);
onClickOutside(filterBody, () => (isFilterVisible.value = false));
</script>

<template>
  <li v-if="props.filter.label != 'manufacturer'" v-for="option in props.filter.options || props.filter.entities"
      :key="`${option.id}-${selectedOptionIds?.includes(option.id)}`"
      v-show="selectedOptionIds?.includes(option?.id)">
    {{ props.filter.label }}: {{ getTranslatedProperty(option, "name") }}
    <a href="javascript:;" @click="emits('select-value', { code: props.filter.code, value: option.id })">
      <svg width="8" height="8" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.146021 1.3539C0.0995332 1.30741 0.0626571 1.25222 0.037498 1.19148C0.0123389 1.13074 -0.000610351 1.06564 -0.000610352 0.999899C-0.000610352 0.934155 0.0123389 0.869055 0.037498 0.808316C0.0626571 0.747576 0.0995332 0.692387 0.146021 0.645899C0.192509 0.599411 0.247698 0.562535 0.308438 0.537376C0.369177 0.512217 0.434277 0.499268 0.500021 0.499268C0.565765 0.499268 0.630865 0.512217 0.691605 0.537376C0.752344 0.562535 0.807533 0.599411 0.854021 0.645899L6.00002 5.7929L11.146 0.645899C11.1925 0.599411 11.2477 0.562535 11.3084 0.537376C11.3692 0.512217 11.4343 0.499268 11.5 0.499268C11.5658 0.499268 11.6309 0.512217 11.6916 0.537376C11.7523 0.562535 11.8075 0.599411 11.854 0.645899C11.9005 0.692387 11.9374 0.747576 11.9625 0.808316C11.9877 0.869055 12.0007 0.934155 12.0007 0.999899C12.0007 1.06564 11.9877 1.13074 11.9625 1.19148C11.9374 1.25222 11.9005 1.30741 11.854 1.3539L6.70702 6.4999L11.854 11.6459C11.9005 11.6924 11.9374 11.7476 11.9625 11.8083C11.9877 11.8691 12.0007 11.9342 12.0007 11.9999C12.0007 12.0656 11.9877 12.1307 11.9625 12.1915C11.9374 12.2522 11.9005 12.3074 11.854 12.3539C11.8075 12.4004 11.7523 12.4373 11.6916 12.4624C11.6309 12.4876 11.5658 12.5005 11.5 12.5005C11.4343 12.5005 11.3692 12.4876 11.3084 12.4624C11.2477 12.4373 11.1925 12.4004 11.146 12.3539L6.00002 7.2069L0.854021 12.3539C0.807533 12.4004 0.752344 12.4373 0.691605 12.4624C0.630865 12.4876 0.565765 12.5005 0.500021 12.5005C0.434277 12.5005 0.369177 12.4876 0.308438 12.4624C0.247698 12.4373 0.192509 12.4004 0.146021 12.3539C0.0995332 12.3074 0.0626571 12.2522 0.037498 12.1915C0.0123389 12.1307 -0.000610352 12.0656 -0.000610352 11.9999C-0.000610352 11.9342 0.0123389 11.8691 0.037498 11.8083C0.0626571 11.7476 0.0995332 11.6924 0.146021 11.6459L5.29302 6.4999L0.146021 1.3539Z" fill="currentColor"></path>
      </svg>
    </a>
  </li>
</template>
